import { Challenge } from "./challenge";

export class CaptchaChallenge extends Challenge {
    private imgSrc = "";
    private refreshSrc = "";

    protected async execute(): Promise<boolean> {
        const cid = this.cdata.result.cid;

        if (!this.processMdata()) {
            this.imgSrc = `${this.core.conf.capi}/m?cid=${cid}&mtype=0`;
            this.refreshSrc = this.core.conf.capi_refreshPng;
        }

        return true;
    }

    async render(parentDiv: HTMLElement): Promise<boolean> {
        if (!parentDiv) { return false; }

        const cres = this.getCresElement();
        const img = window.document.createElement("img");
        const refresh_div = window.document.createElement("div");
        const refresh = window.document.createElement("img");
        const br = window.document.createElement("br");
        const span = window.document.createElement("span");

        const captchaDesc = this.core.conf.getLocalization().captchaDescription || "";

        await this.execute();

        img.className = "c-text";
        img.src = this.imgSrc;

        refresh_div.className = "c-refresh-div";
        refresh.className = "c-refresh";
        refresh.src = this.refreshSrc;
        refresh.tabIndex = 0

        br.className = "c-break";

        span.className = "c-old-ie";
        span.innerHTML = captchaDesc;

        cres.className = "c-input";
        cres.type = "text";
        cres.placeholder = captchaDesc;

        parentDiv.appendChild(img);
        parentDiv.appendChild(refresh_div);
        refresh_div.appendChild(refresh);
        parentDiv.appendChild(br);
        parentDiv.appendChild(span);
        parentDiv.appendChild(cres);

        refresh_div.onclick = this.core.loadChallenge.bind(this.core);

        return true;
    }

    protected processMdata(): boolean {
        if (this.mdata) {
            const captchaMedia = this.mdata.split(",");
            if (captchaMedia.length === Challenge.EXPECTED_MEDIA_LENGTH) {
                this.imgSrc = Challenge.IMAGEDATA + captchaMedia[0];
                this.refreshSrc = Challenge.IMAGEDATA + captchaMedia[1];
                return true;
            }
        }
        return false;
    }
}
